module.exports = __webpack_public_path__ + "media/check.79fbf355.mp3";